import React from 'react'
import { motion } from 'framer-motion'
import { useBrand } from '../branding/BrandProvider'

const TermsPage = () => {
  const brand = useBrand()
  return (
    <div className="pt-16 lg:pt-20 min-h-screen">
      <section className="section-padding py-20">
        <div className="container-max max-w-4xl mx-auto">
          <motion.h1 className="text-4xl font-display font-bold text-white mb-6" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>Terms of Service</motion.h1>
          <div className="glass-card p-8 space-y-4 text-white/80">
            <p>By using {brand.siteName}, you agree to follow our community guidelines and applicable laws. We can moderate or remove content that violates policies.</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Be respectful; no harassment or illegal content</li>
              <li>Only post events/listings you have rights to share</li>
              <li>Transactions must comply with our marketplace rules</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TermsPage

